export const mergeSearchParams = (
  url: URL | string,
  searchParams: URLSearchParams | Record<string, string>,
) => {
  const merged = new URL(url, window.location.href);
  for (const [key, value] of new URLSearchParams(searchParams).entries()) {
    merged.searchParams.set(key, value);
  }
  return merged;
};
